/**
 * JET_FRAME — Kanonik telefon marka/model/slug/URL haritasi.
 *
 * Tek dogru kaynak. jet-device-photos.js (URL haritasi) + insan-okur model adlari
 * burada birlestirilir. model-selector.liquid + jet-model-modal.liquid + atolye
 * core ayni veriyi tuketir, kopya yok.
 *
 * Yukleme sirasi: jet-frame-urls.js -> jet-device-photos.js -> jet-atolye-core.js
 * (canvas.liquid'te bu sira ile yuklenir).
 */
(function () {
  'use strict';

  // ---- Slug normalize ----------------------------------------------------
  // Marka + model adi -> kebab-case slug. jet-device-photos.js'in key'leriyle
  // bire-bir uyumlu olmali. Diakritik ve ozel karakterleri kaldirir.
  var DIACRITIC_MAP = {
    'i': 'i', 'i': 'i', 'I': 'i', 'I': 'i',
    'g': 'g', 'G': 'g',
    'u': 'u', 'U': 'u',
    's': 's', 'S': 's',
    'o': 'o', 'O': 'o',
    'c': 'c', 'C': 'c'
  };

  function stripDiacritics(s) {
    return String(s || '').split('').map(function (ch) {
      return DIACRITIC_MAP[ch] || ch;
    }).join('').normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function toSlug(brand, model) {
    var raw = stripDiacritics(String(model || '')).toLowerCase();
    raw = raw
      .replace(/\+/g, '-plus')
      .replace(/&/g, '-and-')
      .replace(/\//g, '-')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');

    // Brand prefix bazi modellerde gerekli (samsung-galaxy-*, redmi-note-*).
    var brandKey = stripDiacritics(String(brand || '')).toLowerCase();
    if (brandKey === 'samsung' && !/^samsung-/.test(raw)) {
      raw = (raw.indexOf('galaxy') === 0) ? 'samsung-' + raw : 'samsung-galaxy-' + raw.replace(/^galaxy-/, '');
    } else if (brandKey === 'redmi' && !/^redmi-/.test(raw)) {
      raw = 'redmi-' + raw;
    } else if (brandKey === 'oppo' && !/^oppo-/.test(raw)) {
      raw = 'oppo-' + raw;
    } else if (brandKey === 'vivo' && !/^vivo-/.test(raw)) {
      raw = 'vivo-' + raw;
    } else if (brandKey === 'xiaomi') {
      // Xiaomi brand altinda hem 'Xiaomi 14T' hem 'Redmi Note ...' var.
      // Redmi-baslangicli modeller redmi- prefix korur, digerleri xiaomi- alir.
      if (/^redmi-/.test(raw)) {
        // raw zaten redmi-... seklinde, prefix ekleme
      } else if (!/^xiaomi-/.test(raw)) {
        raw = 'xiaomi-' + raw;
      }
    } else if (brandKey === 'apple' && !/^iphone-/.test(raw)) {
      raw = (raw.indexOf('iphone') === 0) ? raw : 'iphone-' + raw;
    }
    return raw;
  }

  // ---- MODELS — insan-okur ad + slug + hasFrame -------------------------
  // hasFrame, jet-device-photos.js'te key olup olmadigi runtime'da hesaplanir.
  // v2 (2026-04-30): 195 model -> 74 model. Apple/Samsung/Xiaomi yalniz.
  // Kaynak: tools/phone-backs/slug_map_v2.csv (74 satir)
  var MODELS = {
    Apple: [
      ['iPhone 18 Pro Max', 'iphone-18-pro-max'],
      ['iPhone 18 Pro', 'iphone-18-pro'],
      ['iPhone 17 Pro Max', 'iphone-17-pro-max'],
      ['iPhone 17 Pro', 'iphone-17-pro'],
      ['iPhone 17 Air', 'iphone-17-air'],
      ['iPhone 17', 'iphone-17'],
      ['iPhone 16 Pro Max', 'iphone-16-pro-max'],
      ['iPhone 16 Pro', 'iphone-16-pro'],
      ['iPhone 16 Plus', 'iphone-16-plus'],
      ['iPhone 16', 'iphone-16'],
      ['iPhone 16e', 'iphone-16e'],
      ['iPhone 15 Pro Max', 'iphone-15-pro-max'],
      ['iPhone 15 Pro', 'iphone-15-pro'],
      ['iPhone 15 Plus', 'iphone-15-plus'],
      ['iPhone 15', 'iphone-15'],
      ['iPhone 14 Pro Max', 'iphone-14-pro-max'],
      ['iPhone 14 Pro', 'iphone-14-pro'],
      ['iPhone 14 Plus', 'iphone-14-plus'],
      ['iPhone 14', 'iphone-14'],
      ['iPhone 13 Pro Max', 'iphone-13-pro-max'],
      ['iPhone 13 Pro', 'iphone-13-pro'],
      ['iPhone 13', 'iphone-13'],
      ['iPhone 13 mini', 'iphone-13-mini'],
      ['iPhone 12 Pro Max', 'iphone-12-pro-max'],
      ['iPhone 12 Pro', 'iphone-12-pro'],
      ['iPhone 12', 'iphone-12'],
      ['iPhone 12 mini', 'iphone-12-mini'],
      ['iPhone 11 Pro Max', 'iphone-11-pro-max'],
      ['iPhone 11 Pro', 'iphone-11-pro'],
      ['iPhone 11', 'iphone-11'],
      ['iPhone Xs Max', 'iphone-xs-max'],
      ['iPhone Xs', 'iphone-xs'],
      ['iPhone Xr', 'iphone-xr']
    ],
    Samsung: [
      ['Samsung Galaxy S26 Ultra', 'samsung-galaxy-s26-ultra'],
      ['Samsung Galaxy S26+', 'samsung-galaxy-s26-plus'],
      ['Samsung Galaxy S26', 'samsung-galaxy-s26'],
      ['Samsung Galaxy S25 Ultra', 'samsung-galaxy-s25-ultra'],
      ['Samsung Galaxy S25+', 'samsung-galaxy-s25-plus'],
      ['Samsung Galaxy S25', 'samsung-galaxy-s25'],
      ['Samsung Galaxy S24 Ultra', 'samsung-galaxy-s24-ultra'],
      ['Samsung Galaxy S24+', 'samsung-galaxy-s24-plus'],
      ['Samsung Galaxy S24 FE', 'samsung-galaxy-s24-fe'],
      ['Samsung Galaxy S24', 'samsung-galaxy-s24'],
      ['Samsung Galaxy S23 Ultra', 'samsung-galaxy-s23-ultra'],
      ['Samsung Galaxy S23+', 'samsung-galaxy-s23-plus'],
      ['Samsung Galaxy S23 FE', 'samsung-galaxy-s23-fe'],
      ['Samsung Galaxy S23', 'samsung-galaxy-s23'],
      ['Samsung Galaxy S22 Ultra', 'samsung-galaxy-s22-ultra'],
      ['Samsung Galaxy S22+', 'samsung-galaxy-s22-plus'],
      ['Samsung Galaxy S22', 'samsung-galaxy-s22'],
      ['Samsung Galaxy S21 Ultra', 'samsung-galaxy-s21-ultra'],
      ['Samsung Galaxy S21+', 'samsung-galaxy-s21-plus'],
      ['Samsung Galaxy S21', 'samsung-galaxy-s21'],
      ['Samsung Galaxy Z Flip7', 'samsung-galaxy-z-flip7'],
      ['Samsung Galaxy Z Flip6', 'samsung-galaxy-z-flip6'],
      ['Samsung Galaxy A57', 'samsung-galaxy-a57'],
      ['Samsung Galaxy A56', 'samsung-galaxy-a56'],
      ['Samsung Galaxy A55', 'samsung-galaxy-a55'],
      ['Samsung Galaxy A36', 'samsung-galaxy-a36'],
      ['Samsung Galaxy A35', 'samsung-galaxy-a35'],
      ['Samsung Galaxy A34', 'samsung-galaxy-a34'],
      ['Samsung Galaxy A26', 'samsung-galaxy-a26'],
      ['Samsung Galaxy A16', 'samsung-galaxy-a16'],
      ['Samsung Galaxy A15', 'samsung-galaxy-a15'],
      ['Samsung Galaxy A07', 'samsung-galaxy-a07']
    ],
    Xiaomi: [
      ['Xiaomi 14T', 'xiaomi-14t'],
      ['Redmi Note 15 Pro', 'redmi-note-15-pro'],
      ['Redmi Note 15', 'redmi-note-15'],
      ['Redmi Note 14 Pro 5G', 'redmi-note-14-pro-5g'],
      ['Redmi Note 14 4G', 'redmi-note-14-4g'],
      ['Redmi Note 13 Pro+', 'redmi-note-13-pro-plus'],
      ['Redmi Note 13 Pro 4G', 'redmi-note-13-pro-4g'],
      ['Redmi Note 13 4G', 'redmi-note-13-4g'],
      ['Redmi Note 12 Pro+', 'redmi-note-12-pro-plus'],
      ['Redmi Note 12 Pro 4G', 'redmi-note-12-pro-4g'],
      ['Redmi Note 12 4G', 'redmi-note-12-4g']
    ]
  };

  // ---- Stok bilgisi (lazy-load) ------------------------------------------
  // jet-stock-models.json fetch edilip in-memory cache. Atolye baslangicinda
  // loadStockManifest() cagrilir; modeller hangi kasa (yesil/magsafe) icin
  // stokta bilinir.
  var _stockManifest = null;
  var _stockLoading = null;
  function loadStockManifest(assetUrlPrefix) {
    if (_stockManifest) return Promise.resolve(_stockManifest);
    if (_stockLoading) return _stockLoading;
    // Faz H-LOOP1: Liquid'den asset_url (versioned ?v=) global URL onceligi
    var url = (typeof window !== 'undefined' && window.JET_STOCK_MANIFEST_URL)
      || ((assetUrlPrefix || '/assets/') + 'jet-stock-models.json');
    _stockLoading = fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (m) {
        if (!m || !Array.isArray(m.in_stock_slugs)) throw new Error('manifest bicimi gecersiz');
        _stockManifest = m;
        return m;
      })
      .catch(function (e) {
        // D-02 (2026-09-25): eskiden hata aninda BOS stok listesi yaziliyordu -> Apple'da 0 kart,
        // filtre kapatilinca 31/31 "Stokta yok", hicbir model secilemiyordu. Artik manifest null kalir
        // (isInStock hepsine true der) ve sonraki cagrida yeniden denenir.
        console.warn('[JET_FRAME] stock manifest fetch fail', e);
        _stockManifest = null;
        _stockLoading = null;
        return null;
      });
    return _stockLoading;
  }
  function isInStock(slug) {
    if (!_stockManifest) return true;  // manifest yuklenmediyse tum modelleri goster
    return _stockManifest.in_stock_slugs.indexOf(slug) >= 0;
  }

  // ---- Public API --------------------------------------------------------
  // v2: 2-katman frame manifest (window.JET_FRAME_PAIRS) varsa onu kullan;
  // yoksa eski tek-katman jet-device-photos.js'e dus.
  function getFramePair(slug) {
    if (window.JET_FRAME_PAIRS && window.JET_FRAME_PAIRS[slug]) {
      return window.JET_FRAME_PAIRS[slug];
    }
    return null;
  }

  function getFrameUrl(slug) {
    var pair = getFramePair(slug);
    if (pair && pair.url_02) return pair.url_02;  // bezel/visible cover
    if (window.JET_DEVICE_PHOTOS) return window.JET_DEVICE_PHOTOS[slug] || null;
    return null;
  }

  function hasFrame(slug) {
    var pair = getFramePair(slug);
    if (pair && pair.url_01 && pair.url_02) return true;
    return !!(window.JET_DEVICE_PHOTOS && window.JET_DEVICE_PHOTOS[slug]);
  }

  // Model bazli teknik not (model kartinda + secimde gosterilir). 2026-10-03
  var NOTES = {
    'iphone-18-pro-max': 'Harici kamera lens koruyucu kullanımında kılıf tam oturmayabilir.',
    'iphone-18-pro': 'Harici kamera lens koruyucu kullanımında kılıf tam oturmayabilir.'
  };

  function getNote(slug) {
    return NOTES[slug] || null;
  }

  function getBrands() {
    return Object.keys(MODELS);
  }

  function getModels(brand, opts) {
    opts = opts || {};
    var arr = MODELS[brand] || [];
    var list = arr.map(function (m) {
      return {
        name: m[0],
        slug: m[1],
        hasFrame: hasFrame(m[1]),
        inStock: isInStock(m[1]),
        note: getNote(m[1]),
      };
    });
    if (opts.onlyInStock) {
      list = list.filter(function (m) { return m.inStock; });
    }
    return list;
  }

  function hasInStockModels(brand) {
    return MODELS[brand].some(function (m) { return isInStock(m[1]); });
  }

  function findBySlug(slug) {
    // A3 (2026-09-25): ?model=IPHONE-15 / bosluklu gelisler de taninsin
    slug = String(slug || '').toLowerCase().trim();
    var brands = Object.keys(MODELS);
    for (var i = 0; i < brands.length; i++) {
      var arr = MODELS[brands[i]];
      for (var j = 0; j < arr.length; j++) {
        if (arr[j][1] === slug) return { brand: brands[i], name: arr[j][0], slug: arr[j][1] };
      }
    }
    return null;
  }

  window.JET_FRAME = {
    MODELS: MODELS,
    toSlug: toSlug,
    getFrameUrl: getFrameUrl,
    getFramePair: getFramePair,
    hasFrame: hasFrame,
    getBrands: getBrands,
    getModels: getModels,
    findBySlug: findBySlug,
    getNote: getNote,
    loadStockManifest: loadStockManifest,
    isInStock: isInStock,
    hasInStockModels: hasInStockModels,
    DEFAULT_BRAND: 'Apple',
    DEFAULT_MODEL: 'iPhone 16 Pro',
    DEFAULT_SLUG: 'iphone-16-pro'
  };
})();
